export const parseSubjectName = (str?: string) => (str ? decodeURIComponent(str)?.replace(/\s+/g, '-') : '');

export function formatSubject(subject?: string) {
  const formatted = subject?.replace(/-/g, ' ') || '';

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}
